<template>
  <div>
    <md-field maxlength="5">
      <label
        >{{ $store.getters.langindex === 1 ? 'Enter your notes here' : 'Qeydlərinizi buraya daxil edə bilərsiniz' }}
        <span style="color: red"> {{ required === 1 ? "*" : "" }} </span></label
      >
      <md-textarea style="resize: none"
        v-model="val"
        @keydown.native="onChange"
      />
    </md-field>
    <answer-required-field v-if="!isvalid"></answer-required-field>
  </div>
</template>

<script>
import AnswerRequiredField from "./AnswerRequiredField";
export default {
  name: "answer-user-input",
  props: {
    required: Boolean,
  },
  components: {
    AnswerRequiredField
  },
  data() {
    return {
      val: "",
      isvalid: true,
    };
  },
  methods: {
    value(){
      return { value: this.val};
    },
    isNegative(){
      return this.value().value ? true : false;
    },
    isValid(){
      return this.required ? this.val ? true : false : true;
    },
    validate() {
      this.isvalid = this.isValid();
      return this.isvalid;
    },
    onChange(){
      this.isvalid = true;
    },
  },
  mounted(){
  },
};
</script>
<style>
</style>